import { getAllEventsAnalytics } from "./get-all-events-analytics";
import { getDeliveryAnalytics } from "./get-delivery-analytics";
import { getDeliveryAnalyticsAggregates } from "./get-delivery-analytics-aggregates";
import { getOrderTrackingAnalytics } from "./get-order-tracking-analytics";
import { getProblemOrdersAnalytics } from "./get-problem-orders-analytics";
import { getTrackingEmailsAndPageAnalyticsAggregates } from "./get-tracking-emails-and-page-analytics-aggregates";
import { getUpsellAnalytics } from "./get-upsell-analytics";

export const orderTrackingAnalyticsSchema = {
  getAllEventsAnalytics,
  getDeliveryAnalytics,
  getDeliveryAnalyticsAggregates,
  getOrderTrackingAnalytics,
  getProblemOrdersAnalytics,
  getTrackingEmailsAndPageAnalyticsAggregates,
  getUpsellAnalytics,
};
